import IconButton from '@mui/material/IconButton';
import { CheckIcon } from '@phosphor-icons/react/dist/csr/Check';
import { TranslateIcon } from '@phosphor-icons/react/dist/csr/Translate';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import styles from './mobileHeader.module.scss';
import { useAppSelector } from '../../../redux/store.ts';
import cn from 'classnames';
import classes from '../userDropdown/userDropdown.module.scss';
import showUserMessage from '../../../utils/showUserMessage.ts';

const LanguageSelector = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { serviceMetadata, currentService } = useAppSelector(state => state.layout);

  const handleClick = () => {
    setIsOpen(prevState => !prevState);
  };

  const isServiceSupportLanguage = (language: string) => {
    if (serviceMetadata) {
      return serviceMetadata.supportedLanguages?.includes(language);
    }
    return false;
  };

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
    window.dispatchEvent(new CustomEvent('OSTS_LANGUAGE_CHANGED', { detail: language }));
    if (!!currentService && !isServiceSupportLanguage(language)) {
      showUserMessage(t('languageSelector.notSupported'), 'warning');
    }
  };

  const getLanguage = () => {
    return i18n.language.split('-')[0];
  };

  const getSortedLanguages = () => {
    const currentLang = getLanguage();
    const languages = [
      { code: 'en', label: 'EN - English' },
      { code: 'de', label: 'DE - Deutsch (German)' },
      { code: 'uk', label: 'UK - Українська (Ukrainian)' },
    ];

    return languages.sort((a, b) => {
      if (a.code === currentLang) return -1;
      if (b.code === currentLang) return 1;
      return a.label.localeCompare(b.label);
    });
  };

  return (
    <div className={cn(styles.languageSelector)}>
      <div className={cn(classes.userMenuItem, styles.languageButton)} onClick={handleClick}>
        <IconButton>
          <TranslateIcon size={24} className={styles.languageIcon} />{' '}
          <span className={styles.languageText}>{getLanguage()}</span>
        </IconButton>
      </div>

      <div className={cn(styles.languageList, { [styles.languageListOpen]: isOpen })}>
        {getSortedLanguages().map((lang, i) => (
          <div
            className={cn(classes.userMenuItem, styles.languageItem)}
            key={lang.code}
            onClick={i !== 0 ? () => changeLanguage(lang.code) : undefined}
          >
            {lang.label}
            {i === 0 && <CheckIcon weight="bold" size={16} />}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LanguageSelector;
